var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#587E85",
    d: "M10.778.111c1.416 0 2.574 1.104 2.661 2.498l.005.169v.888H17c.49 0 .889.399.889.89 0 .453-.34.827-.777.882L17 5.444h-.89L16.111 17c0 1.416-1.104 2.574-2.498 2.661l-.169.006H4.556c-1.417 0-2.575-1.104-2.662-2.498L1.89 17V5.444H1c-.49 0-.889-.398-.889-.888 0-.454.34-.828.777-.882L1 3.667h3.555v-.89c0-1.415 1.104-2.574 2.499-2.66L7.222.11h3.556zM3.666 5.444V17c0 .453.34.827.778.882l.112.007h8.888c.454 0 .828-.34.882-.777l.007-.112V5.444H3.666zm7.112-3.555H7.222c-.453 0-.827.339-.882.777l-.007.112v.888h5.333v-.888c0-.453-.338-.827-.777-.882l-.111-.007z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.6e88f7f095407a033643bcc023499aab.svg";
export { ForwardRef as ReactComponent };